import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom'

import SuspenseWrapper from "./components/wrapper"

const Layout = React.lazy(() => import('./components/layout/index'))
const pages = [
    { path: "/", Component: React.lazy(() => import('./components/pages/main')), exact: true },
    
    { path: "transactions", Component: React.lazy(() => import('./components/pages/transactions')) },
    { path: "transaction-accounts", Component: React.lazy(() => import('./components/pages/transactionAccounts')) },
    { path: "transaction-categories", Component: React.lazy(() => import('./components/pages/transactionItems')) },
    { path: "transaction-tags", Component: React.lazy(() => import('./components/pages/transactionTags')) },
    
    { path: "budget", Component: React.lazy(() => import('./components/pages/budget')) },

    { path: "report-categories", Component: React.lazy(() => import('./components/pages/reportCategories')) },
    { path: "report-recurrings", Component: React.lazy(() => import('./components/pages/reportRecurrings')) },
    { path: "report-by-tag", Component: React.lazy(() => import('./components/pages/reportByTag')) },
    
    { path: "settings", Component: React.lazy(() => import('./components/pages/settings')) },

    { path: "*", Component: React.lazy(() => import('./components/pages/404/index')) },
]

function App() {

    useEffect(() => {
        document.documentElement.classList.toggle('dark', true);
    }, [])

    return (
        <BrowserRouter>
            <Routes>

                <Route 
                    path="/" 
                    element={<SuspenseWrapper Component={Layout} />}
                >
                    {pages.map(({ path, Component }, index) => (
                    <Route
                        key={index}
                        path={path}
                        element={<SuspenseWrapper Component={Component} />}
                    />
                    ))}
                </Route>

            </Routes>
        </BrowserRouter>
    );
}

export default App;